import React,{ useState } from 'react';
import{Button} from '@progress/kendo-react-buttons';
import './card-style.css';
import CusProgressBar from '../components/CusProgressBar';
import config from '../appconfig/config.json';
import accopeningdata from '../data/accopeningdata.json'
import { Form, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import CusFormCb from '../components/CusFormCb';
 


const configData = accopeningdata;

const Cards = (props) => {
    const item = { bgcolor: "#389A6E", completed: 90 };
 

    const [acctOpening22, setAcctOpening22] = useState({
        LoanRepay:false,
        Transactional:false
    })
        
    //handle checkbox checked change
    const [showPurposesOthDesc, setShowPurposesOthDesc] = React.useState(false);

    const handleSubmit = (eve) => {
        let data = JSON.parse(JSON.stringify(eve))

    }
    
    const handleBusizActiChkboxChange = (checkedValue,id) =>{
        
    }

    return (
            
        <div id="" className="">           
        
        {/* <div className="hdImgTxt"> 
            <img src={img2} alt="Imag1" className="img-fluid"/>
            <span className="headTxt">&nbsp;&nbsp;<b>Singapore</b> 
            </span>         
        </div>  */}
        <br/>
        <p className="bgtxt k-align-items-center">Business Account Opening<br/>SME Banking</p> 
{/*         
            <div className="outerdivsubheader">
                <div className="row">
                    <div className="col-12">
                        <h2 className='welcome mb-0'>Business Account Opening<br/>SME Banking</h2>
                    </div>
                </div>
            </div> */}
        
        <div className="container-fluid" style={{ textAlign: "center"}} >
            
          {/* <Card style={{ marginTop: '15px' }}> */}
                
            <Form onSubmit={handleSubmit} 
                initialValues={acctOpening22}
                key={JSON.stringify(acctOpening22)}
                render={(formRenderProps)=>(
                    <FormElement>
                        <FormContainer>
                            <fieldset>
                                <div className="row around-xs elementVisible" style={{ marginTop: "1rem" }}>
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <legend>{configData.declarChkbox.header}</legend>
                                    </div>
                                </div>						
						
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ textAlign: "left"}}>
                                        {configData.declarChkbox.data.map((item, idx) => (
                                                <CusFormCb key={idx} 
                                                id={item.id} lblname ={(<>{item.lblname1} <a className="txtBlue" href={item.hrefLink}>{item.lblname2}</a> {item.lblname3}</>)} 
                                                onCheckedChange={handleBusizActiChkboxChange}
                                            />))}
                                         </div>
                                </div>
                               
                                <div className="padDTC" style={{ textAlign: "left"}}> 
                                    <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} />
                                    <br/>
                                    
                                    <div className="row around-xs inputPair elementVisible">
                                        <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{paddingBottom: "20px"}}>
                                            <Button look="outline" className="btPce">{config.btnName.Back}</Button>                                
                                            <Button primary={true}  className="btPce btRht2 greenbtn2">{config.btnName.Next}</Button>  
                                    
                                            {/* <button className="btn btn-back">{config.btnName.Back}</button>
                                            <button type={'submit'} className="btn btn-success btn-float-right">{config.btnName.Next}</button> */}
                                        </div>
                                    </div>                               
                                
                                </div> 
                            </fieldset>
                        </FormContainer>
                    </FormElement>
                )}>
            </Form>                                         
                               
                    <br/><br/>                 

            <br/>
            <br/><br/> 
          {/* </Card> */}
        </div>
     
      </div>

        );
    
}

export default Cards;

